// Kept import-free (like push-error-classifier.ts) so it stays unit-testable
// in vitest's node environment.

/**
 * Duplicate-push guard for notification deep links (TASKHEALTH-MOBILE-1F).
 *
 * Pushing the same href twice in quick succession — two taps, or the tap
 * listener and the cold-start getLastNotificationResponse path racing — makes
 * react-native-screens enqueue the same RNSScreen instance twice in one CA
 * transaction, which crashes natively with NSInvalidArgumentException
 * ("pushing the same view controller instance more than once"). The response-id
 * dedupe catches the SAME response delivered twice; this catches DIFFERENT
 * responses (or paths) resolving to the same destination.
 */
export interface LastPush {
    href: string;
    at: number;
}

export const DUPLICATE_PUSH_WINDOW_MS = 1_500;

/** Mutates `last` and returns true when the push should proceed. */
export function shouldPushDeepLink(last: LastPush, href: string, now: number): boolean {
    if (last.href === href && now - last.at < DUPLICATE_PUSH_WINDOW_MS) {
        return false;
    }
    last.href = href;
    last.at = now;
    return true;
}
